const type1 = (data, billing) => {
  if (data)
    return "Your digital inheritance mechanism is inactive. To activate it, you need at least one asset associated with one beneficiary.";
  else return;
};
const type2 = (data) => {
  return data.map((e) => {
    return `Your asset ${e.id} is not associated with any active beneficiary.`;
  });
};
const type3 = (data) => {
  return data.map((e) => {
    return `Your beneficiary ${e.id} is not inheriting any asset.`;
  });
};
const type4 = (data) => {
  return data.map((e) => {
    return `Your asset ${e.id} has no Trusted Advisor.`;
  });
};
const type5 = (data) => {
  if (data) {
    return `Your subscription data is limited to 3 months. Ensure your loved ones will inherit your assets by extending your subscription with our plans`;
  } else {
    return;
  }
};
export const handleAdminIssues = (issues) => {
  const issues_ = [].concat(...issues);
  const type1_issues = type1(issues_.filter((e) => e.type === 1));
  const type2_issues = type2(issues_.filter((e) => e.type === 2));
  const type3_issues = type3(issues_.filter((e) => e.type === 3));
  const type4_issues = type4(issues_.filter((e) => e.type === 4));
  const type5_issues = type5(issues_.filter((e) => e.type === 5));
  const issues_joint = [
    type1_issues,
    type2_issues,
    type3_issues,
    type4_issues,
    type5_issues,
  ];

  return [].concat(...issues_joint);
};
